export default __webpack_public_path__ + "static/media/biblio_logo.117bfeda.png";